<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Cập nhật chính sách tính KPI</h1>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <div class="p-10">
          <div class="row">
            <div class="col-md-5">
              <label>Loại dịch vụ:</label>
              {{ dataView.typeService | serviceType }}
            </div>
            <div class="col-md-7">
              <label>Gói:</label> {{ dataView.packageService | packageService }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <label>Dịch vụ:</label> {{ dataView.service }}
            </div>
            <div class="col-md-7">
              <label>Thiết bị kèm theo:</label>
              {{
                dataView.softwareCategory
                  ? joinArray(dataView.softwareCategory)
                  : dataView.categoryCode
              }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-5">
              <label>KPI tiêu chuẩn:</label> {{ dataView.kpiStandard }}
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="text-head">
              Chính sách áp dụng
              <span
                class="pull-right icon-add-policy"
                v-b-tooltip.hover title="Thêm mới"
                @click="clickOpenCreateItem"
                ><i class="bx bx-plus-circle"></i
              ></span>
            </div>
            <form class="box-search box-search-ext">
              <div class="form-group">
                <Select2MultipleControl
                    :settings="{ placeholder: 'Nguồn', closeOnSelect: false }"
                    v-model="arrSearch.refer"
                    :options="optionSource"
                  >
                </Select2MultipleControl>
              </div>
              <div class="form-group">
                <Select2MultipleControl
                    :settings="{ placeholder: 'Loại MC', closeOnSelect: false }"
                    v-model="arrSearch.typeMc"
                    :options="optionMcKeyLvl"
                  >
                </Select2MultipleControl>
              </div>
              <div class="form-group">
                <Select2MultipleControl
                    :settings="{ placeholder: 'Hình thức', closeOnSelect: false }"
                    v-model="arrSearch.typeContract"
                    :options="optionMCType"
                  >
                </Select2MultipleControl>
              </div>
              <div class="form-group">
                <DateRangePicker
                  class="w-100"
                  :ranges="false"
                  v-model="dateRangeSearch"
                  :locale-data="Config.localeData"
                >
                  <template v-slot:input="picker">
                    <label
                      v-if="picker.startDate && picker.endDate"
                      style="min-width: 11.5em; margin-left: -5px !important;"
                      class="pt-1 text-center"
                    >
                      {{ picker.startDate | formatDate }} -
                      {{ picker.endDate | formatDate }}
                    </label>
                    <label
                      v-else
                      style="min-width: 13.5em"
                      class="font-size-12 time-placeholder"
                    >
                      Ngày bắt đầu
                    </label>
                  </template>
                </DateRangePicker>
              </div>
              <div class="form-group form-group-action">
                <button
                  type="button"
                  class="btn btn-primary hc-37 mr-2 pt-2"
                  @click="submitSearchForm"
                >
                  <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
                </button>
                <button
                  type="button"
                  class="btn btn-outline-light hc-37 mr-2 pt-2"
                  @click="clearSearch"
                >
                  <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
                </button>
              </div>
            </form>
            <div class="mt-1 b-table-sticky-header table-responsive">
              <table
                class="table b-table table-hover table-bordered b-table-fixed table-ext"
              >
                <thead>
                  <tr>
                    <th class="table-b-table-default" width="10%">
                      Nguồn <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="10%">
                      Loại Merchant <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="10%">
                      MC đã khóa <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="8%">
                      Hình thức <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="8%">
                      Giới hạn dưới <span>(*)</span><br />STT tính KPI
                    </th>
                    <th class="table-b-table-default" width="8%">
                      Giới hạn trên <span>(*)</span><br />STT tính KPI
                    </th>
                    <th class="table-b-table-default" width="8%">
                      Phần trăm tính KPI <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="8%">
                      KPI áp dụng <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="15%">
                      Ngày áp dụng <span>(*)</span>
                    </th>
                    <th class="table-b-table-default" width="10%">
                      Trạng thái
                    </th>
                    <th class="table-b-table-default" width="10%">Thao tác</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(value, index) in dataListPolicyRes" :key="index">
                    <td>
                      {{
                        value.refer
                          ? joinArrayData(value.refer, optionSource)
                          : value.refer
                      }}
                    </td>
                    <td>
                      {{
                        value.typeMc
                          ? joinArrayData(value.typeMc, optionMcKeyLvl)
                          : value.typeMc
                      }}
                    </td>
                    <td>
                      {{
                        value.statusMc
                          ? joinArrayData(value.statusMc, optionMCLock)
                          : value.statusMc
                      }}
                    </td>
                    <td>
                      {{
                        value.typeContract
                          ? joinArrayData(value.typeContract, optionMCType)
                          : value.typeContract
                      }}
                    </td>
                    <td class="text-right">{{ value.limitFrom }}</td>
                    <td class="text-right">{{ value.limitTo }}</td>
                    <td class="text-right">{{ value.ratio }}%</td>
                    <td class="text-right">{{ value.kpi }}</td>
                    <td>
                      {{ value.startTime | formatDate }}-{{
                        value.endTime | formatDate
                      }}
                    </td>
                    <td>
                      {{
                        value.status
                          ? mapStatus(value.status, optionStatus)
                          : value.status
                      }}
                    </td>
                    <td class="nowrap">
                      <span @click="clickCopyKpiPolicy(value)"
                        v-b-tooltip.hover title="Copy"
                        ><i class="bx bx-copy fs-20 default"></i
                      ></span>
                      <span v-if="value.status == 'NEW'">
                        <span @click="clickApproveKpiPolicy(value.id)"
                          v-b-tooltip.hover title="Duyệt"
                          ><i class="bx bx-check fs-28 green"></i
                        ></span>
                        <span @click="clickUpdateKpiPolicy(value)"
                          v-b-tooltip.hover title="Sửa"
                          ><i class="bx bx-edit-alt fs-20 blue"></i
                        ></span>
                      </span>
                      <span v-if="value.status == 'ACTIVE'">
                        <span @click="clickOpenLockModal(value.id)"
                          v-b-tooltip.hover title="Khóa"
                          ><i class="bx bx-lock fs-20 orangered"></i
                        ></span>
                      </span>
                    </td>
                  </tr>
                  <tr v-if="openCreateItem">
                    <td>
                      <Select2MultipleControl
                          :settings="{ placeholder: 'Nguồn', closeOnSelect: false }"
                          v-model="arrAttribute.refer"
                          :options="optionSource"
                          class="w-100px"
                        >
                      </Select2MultipleControl>
                    </td>
                    <td>
                      <Select2MultipleControl
                          :settings="{ placeholder: 'Loại MC', closeOnSelect: false }"
                          v-model="arrAttribute.typeMc"
                          :options="optionMcKeyLvl"
                          class="w-100px"
                        >
                      </Select2MultipleControl>
                    </td>
                    <td>
                      <Select2MultipleControl
                          :settings="{ placeholder: 'Đã khóa', closeOnSelect: false }"
                          v-model="arrAttribute.statusMc"
                          :options="optionMCLock"
                          class="w-100px"
                        >
                      </Select2MultipleControl>
                    </td>
                    <td>
                      <Select2MultipleControl
                          :settings="{ placeholder: 'Hình thức', closeOnSelect: false }"
                          v-model="arrAttribute.typeContract"
                          :options="optionMCType"
                          class="w-100px"
                        >
                      </Select2MultipleControl>
                    </td>
                    <td>
                      <b-form-input
                        class="w-150px"
                        v-model.number="paramsAttribute.limitFrom"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        class="w-150px"
                        v-model.number="paramsAttribute.limitTo"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        class="w-150px"
                        v-model.number="paramsAttribute.ratio"
                      ></b-form-input>
                    </td>
                    <td>
                      <b-form-input
                        class="w-150px"
                        v-model.number="paramsAttribute.kpi"
                      ></b-form-input>
                    </td>
                    <td>
                      <DateRangePicker
                        class="w-100"
                        :ranges="false"
                        v-model="dateRange"
                        :locale-data="Config.localeData"
                      >
                        <template v-slot:input="picker">
                          <label
                            v-if="picker.startDate && picker.endDate"
                            style="min-width: 11.5em; margin-left: -5px !important;"
                            class="pt-1 text-center"
                          >
                            {{ picker.startDate | formatDate }} -
                            {{ picker.endDate | formatDate }}
                          </label>
                          <label
                            v-else
                            style="min-width: 13.5em"
                            class="font-size-12 time-placeholder"
                          >
                            Ngày tạo
                          </label>
                        </template>
                      </DateRangePicker>
                    </td>
                    <td></td>
                    <td>
                      <span
                        @click="clickCreateKpiPolicy"
                        v-if="paramsAttribute.id == null"
                        v-b-tooltip.hover title="Lưu"
                        ><i class="bx bx-save green"></i
                      ></span>
                      <span @click="clickUpdateSaveKpiPolicy" v-else
                        v-b-tooltip.hover title="Cập nhật"
                        ><i class="bx bx-save green"></i
                      ></span>
                      <span class="ml-1" @click="removeCreateKpiPolicy"
                        v-b-tooltip.hover title="Xóa"
                        ><i class="bx bxs-x-circle red"></i
                      ></span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="text-danger" v-show="errorMessage">
                <i class="bx bx-error-alt"></i> {{ errorMessage }}
              </p>
            </div>
          </div>
        </div>
        <VueLoadingOverlay
          :active.sync="loading"
          :is-full-page="true"
        ></VueLoadingOverlay>
        <b-modal id="modal-scoped" v-model="openLockModal">
          <template #modal-header="{ close }">
            <h5>Khóa dịch chính sách KPI</h5>
            <b-button size="sm" variant="light" @click="close()">
              x
            </b-button>
          </template>
          <b-form-group>
            <label>Lý do <span class="text-red">(*)</span></label>
            <b-form-input v-model="note"></b-form-input>
          </b-form-group>
          <template #modal-footer="{ cancel }">
            <b-button variant="light" @click="cancel()">
              Hủy bỏ
            </b-button>
            <b-button variant="primary" @click="clickLockKpiPolicy()">
              Lưu
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { KpiSaleConfigService } from "@/services/kpi.sale.config.service";
import cloneDeep from "lodash/cloneDeep";
import Config from "@/thirdParty/config";
import moment from "moment";

export default {
  data() {
    return {
      Config,
      loading: false,
      dataView: {},
      dataListPolicyRes: [],
      search: {
        kpiStandardId: "",
        limit: 1000,
        page: 1
      },
      arrSearch: {
        refer: [],
        typeMc: [],
        typeContract: []
      },
      initArrSearch: {
        refer: [],
        typeMc: [],
        typeContract: []
      },
      dateRangeSearch: {
        startDate: null,
        endDate: null
      },
      errorMessage: "",
      openCreateItem: false,
      paramsItem: {
        kpiStandard: 0
      },
      dateRange: {
        startDate: "",
        endDate: ""
      },
      optionSource: [
        { id: "SALES", text: "Sales" },
        { id: "AGENCY", text: "Cộng tác viên" },
        { id: "MARKETING", text: "Marketing" },
        { id: "AFTER_SALE", text: "After Sale" },
        { id: "TELESALE", text: "Telesale" },
        { id: "OP_AFTER_SALE", text: "Vận hành CSKH tạo" }
      ],
      optionMcKeyLvl: Config.mcKeyLvl,
      optionMCLock: [
        { id: "ACTIVE", text: "Chưa khóa" },
        { id: "INACTIVE", text: "Đã khóa trước 31/12/23" }
      ],
      optionMCType: [
        { id: "CONTRACT", text: "Mua mới" },
        { id: "APPENDIX", text: "Mua thêm" }
      ],
      optionStatus: [
        { id: "NEW", text: "Mới tạo" },
        { id: "INACTIVE", text: "Đã khóa" },
        { id: "ACTIVE", text: "Đang áp dụng" }
      ],
      paramsAttribute: {
        endTime: 0,
        startTime: 0,
        id: null,
        kpi: 0,
        kpiStandardId: "",
        limitFrom: 0,
        limitTo: 0,
        ratio: 0,
        refer: [],
        statusMc: [],
        typeContract: [],
        typeMc: []
      },
      initItemAttribute: {
        endTime: 0,
        startTime: 0,
        id: null,
        kpi: 0,
        kpiStandardId: "",
        limitFrom: 0,
        limitTo: 0,
        ratio: 0,
        refer: [],
        statusMc: [],
        typeContract: [],
        typeMc: []
      },
      arrAttribute: {
        refer: [],
        statusMc: [],
        typeContract: [],
        typeMc: []
      },
      openLockModal: false,
      lock_id: "",
      note: ""
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    async submitSearchForm() {
      this.search.page = 1;
      this.fetchData();
    },
    clearSearch() {
      this.search = {
        limit: 1000,
        page: 1
      };
      this.dateRangeSearch = {
        startDate: null,
        endDate: null
      };
      this.arrSearch = cloneDeep(this.initArrSearch);
      this.fetchData();
    },
    async fetchData() {
      try {
        this.loading = true;
        const search = cloneDeep(this.search);
        search.kpiStandardId = this.$route.params.id;

        if (this.arrSearch.refer && this.arrSearch.refer.length > 0) {
          search.refer = this.arrSearch.refer;
        }
        if (this.arrSearch.typeContract && this.arrSearch.typeContract.length > 0) {
          search.typeContracts = this.arrSearch.typeContract;
        }
        if (this.arrSearch.typeMc && this.arrSearch.typeMc.length > 0) {
          search.typeMc = this.arrSearch.typeMc;
        }
        if (this.dateRangeSearch.startDate && this.dateRangeSearch.endDate) {
          search.startedDateTo = moment(this.dateRangeSearch.endDate)
            .endOf("day")
            .valueOf()
            .toString();
          search.startedDateFrom = moment(this.dateRangeSearch.startDate)
            .startOf("day")
            .valueOf()
            .toString();
        }

        const data = await KpiSaleConfigService.kpiPolicyConfigView(search);
        if (data.success) {
          this.dataView = data.data;
          this.dataListPolicyRes = data.data.listPolicyRes
            ? data.data.listPolicyRes
            : [];
          if (this.dataListPolicyRes.length > 0) {
          }
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    joinArray(item) {
      return item.join(", ");
    },
    joinArrayData(item, options) {
      const strs = [];
      if (item.length > 0) {
        item.forEach(value => {
          options.forEach(obj => {
            if (obj.id == value) {
              strs.push(obj.text);
            }
          });
        });
      }
      return strs.join(", ");
    },
    mapStatus(status, options) {
      let strs = status;
      options.forEach(obj => {
        if (obj.id == status) {
          strs = obj.text;
        }
      });
      return strs;
    },
    clickOpenCreateItem() {
      this.openCreateItem = !this.openCreateItem;
      this.paramsAttribute = {};
      this.arrAttribute = {};
      this.dateRange = {
        startDate: null,
        endDate: null
      };
    },
    async clickCreateKpiPolicy() {
      this.paramsAttribute.id = null;
      this.paramsAttribute.kpiStandardId = this.$route.params.id;
      if (this.dateRange.startDate != "" && this.dateRange.endDate != "") {
        this.paramsAttribute.endTime = moment(this.dateRange.endDate)
          .endOf("day")
          .valueOf()
          .toString();
        this.paramsAttribute.startTime = moment(this.dateRange.startDate)
          .startOf("day")
          .valueOf()
          .toString();
      }

      if (this.arrAttribute.refer && this.arrAttribute.refer.length > 0) {
        this.paramsAttribute.refer = this.arrAttribute.refer;
      }
      if (this.arrAttribute.statusMc && this.arrAttribute.statusMc.length > 0) {
        this.paramsAttribute.statusMc = this.arrAttribute.statusMc;
      }
      if (this.arrAttribute.typeContract && this.arrAttribute.typeContract.length > 0) {
        this.paramsAttribute.typeContract = this.arrAttribute.typeContract;
      }
      if (this.arrAttribute.typeMc && this.arrAttribute.typeMc.length > 0) {
        this.paramsAttribute.typeMc = this.arrAttribute.typeMc;
      }

      try {
        this.loading = true;
        const data = await KpiSaleConfigService.kpiPolicyConfigCreateAttribute(
          this.paramsAttribute
        );
        if (data.success) {
          await this.fetchData();
          this.paramsAttribute = {};
          this.arrAttribute = {};
          this.errorMessage = "";
          this.openCreateItem = false;
          this.loading = false;
        }
      } catch (error) {
        this.errorMessage = error;
      } finally {
        this.loading = false;
      }
    },
    removeCreateKpiPolicy() {
      this.paramsAttribute = {};
      this.arrAttribute = {};
      this.errorMessage = "";
      this.openCreateItem = false;
    },
    async clickApproveKpiPolicy(id) {
      try {
        if (id !== "") {
          this.loading = true;
          const params = { id: id };
          const data = await KpiSaleConfigService.kpiPolicyConfigApproveAttribute(
            params
          );
          if (data.success) {
            await this.fetchData();
            this.loading = false;
          }
        }
      } catch (error) {
        this.errorMessage = error;
      } finally {
        this.loading = false;
      }
    },
    async clickUpdateKpiPolicy(item) {
      this.openCreateItem = true;
      this.paramsAttribute = {
        endTime: 0,
        startTime: 0,
        id: item.id,
        kpi: item.kpi,
        kpiStandardId: item.kpiStandardId,
        limitFrom: item.limitFrom,
        limitTo: item.limitTo,
        ratio: item.ratio
      };
      this.arrAttribute = {
        refer: item.refer,
        statusMc: item.statusMc,
        typeContract: item.typeContract,
        typeMc: item.typeMc
      };
      this.dateRange = {
        startDate: item.startTime,
        endDate: item.endTime
      };
    },
    async clickUpdateSaveKpiPolicy() {
      if (this.dateRange.startDate != "" && this.dateRange.endDate) {
        this.paramsAttribute.endTime = moment(this.dateRange.endDate)
          .endOf("day")
          .valueOf()
          .toString();
        this.paramsAttribute.startTime = moment(this.dateRange.startDate)
          .startOf("day")
          .valueOf()
          .toString();
      }

      if (this.arrAttribute.refer && this.arrAttribute.refer.length > 0) {
        this.paramsAttribute.refer = this.arrAttribute.refer;
      }
      if (this.arrAttribute.statusMc && this.arrAttribute.statusMc.length > 0) {
        this.paramsAttribute.statusMc = this.arrAttribute.statusMc;
      }
      if (this.arrAttribute.typeContract && this.arrAttribute.typeContract.length > 0) {
        this.paramsAttribute.typeContract = this.arrAttribute.typeContract;
      }
      if (this.arrAttribute.typeMc && this.arrAttribute.typeMc.length > 0) {
        this.paramsAttribute.typeMc = this.arrAttribute.typeMc;
      }
      try {
        this.loading = true;
        const data = await KpiSaleConfigService.kpiPolicyConfigUpdateAttribute(
          this.paramsAttribute
        );
        if (data.success) {
          await this.fetchData();
          this.paramsAttribute = {};
          this.arrAttribute = {};
          this.errorMessage = "";
          this.openCreateItem = false;
          this.loading = false;
        }
      } catch (error) {
        this.errorMessage = error;
      } finally {
        this.loading = false;
      }
    },
    clickOpenLockModal(id) {
      this.openLockModal = true;
      this.lock_id = id;
    },
    async clickLockKpiPolicy() {
      try {
        if (this.lock_id !== "" && this.note !== "") {
          this.loading = true;
          const params = { id: this.lock_id, note: this.note };
          const data = await KpiSaleConfigService.kpiPolicyConfigLockAttribute(
            params
          );
          if (data.success) {
            await this.fetchData();
            this.loading = false;
            this.openLockModal = false;
            this.lock_id = "";
            this.note = "";
          }
        }
      } catch (error) {
        this.errorMessage = error;
      } finally {
        this.loading = false;
      }
    },
    clickCopyKpiPolicy(item) {
      this.openCreateItem = true;
      this.paramsAttribute = {
        endTime: item,
        startTime: 0,
        id: null,
        kpi: item.kpi,
        kpiStandardId: item.kpiStandardId,
        limitFrom: item.limitFrom,
        limitTo: item.limitTo,
        ratio: item.ratio
      };
      this.arrAttribute = {
        refer: item.refer,
        statusMc: item.statusMc,
        typeContract: item.typeContract,
        typeMc: item.typeMc
      };
      this.dateRange = {
        startDate: item.startTime,
        endDate: item.endTime
      };
    }
  }
};
</script>
<style scoped>
.card-header {
  font-size: 14px;
}
.card-header label {
  font-weight: bold;
  width: 20%;
  display: inline-block;
}
.text-head {
  font-size: 14px;
  font-weight: bold;
}
.table-ext th span {
  color: #ff0000;
}
.icon-add-policy {
  font-size: 25px;
  cursor: pointer;
  color: green;
  margin-right: 10px;
}
.w-100px {
  width: 100px;
}
.w-150px {
  width: 120px;
}
.green {
  color: green;
  font-size: 22px;
  cursor: pointer;
  display: inline-block;
}
.red {
  color: red;
  font-size: 22px;
  cursor: pointer;
  display: inline-block;
}
.blue {
  color: blue;
  font-size: 22px;
  cursor: pointer;
  display: inline-block;
}
.orangered {
  color: orangered;
  font-size: 22px;
  cursor: pointer;
  display: inline-block;
}
.default {
  color: #555;
  font-size: 15px;
  cursor: pointer;
  display: inline-block;
}
.fs-20 {
  font-size: 20px !important;
}
.fs-28 {
  font-size: 28px !important;
}
.nowrap {
  white-space: nowrap;
}
.text-red {
  color: #ff0000;
}
.box-search-ext {
  padding: 0 2px !important;
}
</style>
